import React, { FC, useEffect, useRef, useState, useMemo } from "react";
import { Row, Col, Button, Modal, ModalBody } from "reactstrap";
import { useFormContext } from "react-hook-form";
import FormInput from "../form-components/InputComponent";
import FormSelect from "../form-components/SelectComponent";
import { Icon } from "../../components/Component";
import FormDatePicker from "../form-components/DatePicker";
import { Divider, Space, Popover, Tooltip, Radio, Modal as AntdModal, message } from "antd";
import DeliveryAddressMaster from "../masters/delivery-address/DeliveryAddressMaster";
import deliveryAddressApis from "../../api/master/deliveryAddress";
import { EditOutlined, InfoCircleOutlined, SettingOutlined } from "@ant-design/icons";
import budgetApis from "../../api/master/budget";
import purchaseOrderCreation from "../../api/purchase-orders/pruchaseOrderCreation";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import contractorsApis from "../../api/master/contractors";
import SettingsForm from "./SettingsForm";
import sequenceApis from "../../api/master/sequence";
import RateContractApprovalDrawer from "./RateContractApprovalDrawer";
import FormMultiSelect from "../form-components/MultiSelectComponent";
import dayjs from "dayjs";
interface SelectOptions {
  label: string;
  value: string;
}

const RATE_CONTRACT_MODULE_ID = 81;

const RateContract_GeneralDetails: FC = (props: any) => {
  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  const [activeSequences, setActiveSequences] = useState<any[]>([]);
  const [numberingMode, setNumberingMode] = useState<'auto' | 'manual'>('auto');
  const [showNumberingModal, setShowNumberingModal] = useState(false);
  const [tempNumberingMode, setTempNumberingMode] = useState<'auto' | 'manual'>('auto');
  const dispatch: any = useDispatch();
  const {
    handleSubmit,
    watch,
    setValue,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
  } = useFormContext();
  const [contractorOptions, setContractorOptions] = useState<SelectOptions[]>(
    []
  );
  const [supplierOptions, setSupplierOptions] = useState<SelectOptions[]>([]);

  const [sitesOptions, setSitesOptions] = useState<SelectOptions[]>([]);
  const [budgetOptions, setBudgetOptions] = useState<SelectOptions[]>([]);
  const [budgetList, setBudgetList] = useState<any>([]);
  const [deliveryAddressList, setDeliveryAddressList] = useState<any>([]);
  const [deliveryAddressOptions, setDeliveryAddressOptions] = useState<
    SelectOptions[]
  >([]);
  const [popUpContent, setPopUpContent] = useState<JSX.Element | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [approvals, setApprovals] = useState({
    open: false,
    data: [],
  });
  const [isStrictApproval, setIsStrictApproval] = useState<boolean>(false);
  const [isFormDataFetched, setIsFormDataFetched] = useState(false);
  const AllFormDetails = watch();
  const needByDateType = watch("needByDateType");
  const deliveryAddressId = watch("deliveryAddressId");
  const billingAddressId = watch("billingAddressId");
  const approvalRequired = watch("approvalRequired");
  const siteIdWatch = watch("siteId");
  const budgetIdWatch = watch("budgetId");
  const contractDate = watch("contractDate");
  const startDate = watch("startDate");
  const endDate = watch("endDate");
  const [settings, setSettings] = useState({
    open: false,
    data: {},
  });
  const openSettingsForm = () => {
    setSettings((prev) => ({
      ...prev,
      open: true,
    }));
  };
  const handleSettingsSubmit = (updatedSettings: any) => {
    setSettings({
      open: false,
      data: updatedSettings,
    });
    // Apply updated settings values in main form (RFQGeneralDetails)
    setValue("inwardRequired", updatedSettings.inwardRequired);
    setValue("autoPoDoc", updatedSettings.autoPoDoc);
    setValue("invoicingRequired", updatedSettings.invoicingRequired);
    setValue("priceSlabs", updatedSettings.priceSlabs);
  };

  useEffect(() => {
    if (siteIdWatch) {
      fetchBudgetDetails(siteIdWatch);
      fetchContractorList(siteIdWatch);
    }
  }, [siteIdWatch]);

  const submitForm = (data: any) => {
    console.log("data", data);

    // Validate that contract date is on or before start date
    if (data.contractDate && data.startDate) {
      const contract = dayjs(data.contractDate);
      const start = dayjs(data.startDate);

      if (contract.isValid() && start.isValid() && contract.isAfter(start)) {
        setError("contractDate", {
          type: "manual",
          message: "Contract date must be on or before start date",
        });
        return;
      } else {
        clearErrors("contractDate");
      }
    }

    setValue("approvalsData", JSON.stringify(approvals));
    setValue("isStrictApproval", isStrictApproval);
    setValue("numberingMode", numberingMode);
    if (approvalRequired == "false" && approvals?.data?.length === 0) {
      return;
    }
    props?.next();
  };

  const fetchSupplier = async () => {
    try {
      const res: any =
        await purchaseOrderCreation.fetchBuyerLinkedSupplierListMethod();
      const { data, status } = res;
      if (status) {
        let supplierOptions = data.map((item: any) => ({
          label: item?.sellerOrg?.name,
          value: item?.sellerOrg?.orgId?.toString(),
        }));
        setSupplierOptions(supplierOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchContractorList = async (siteId: any) => {
    try {
      const { data, status } = await contractorsApis.fetchContractorBySiteId({
        id: "" + siteId,
      });
      if (status) {
        let contractorOptions = data.map((item: any) => ({
          label: item?.companyName,
          value: item?.contractorID?.toString(),
        }));
        setContractorOptions(contractorOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBudgetDetails = async (siteId: any) => {
    try {
      const { data, status } = await budgetApis.getBudgetBySite(siteId);

      if (status) {
        let budgetOptions = data.map((item: any) => ({
          label: item.budgetName,
          value: item.headerId,
        }));
        setBudgetOptions(budgetOptions);
        setBudgetList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDeliveryAddress = async () => {
    try {
      const { data, status } = await deliveryAddressApis.fetchDeliveryAddress();
      if (status) {
        let deliveryAddressOptions = data.map((item: any) => ({
          label: item.deliveryLocationName,
          value: item.id.toString(),
        }));
        setDeliveryAddressOptions(deliveryAddressOptions);
        setDeliveryAddressList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDeliveryAddressBySite = async (siteId: any) => {
    try {
      const { data, status } = await deliveryAddressApis.fetchAddressBySite(
        siteId
      );

      if (status) {
        let deliveryAddressOptions = data.map((item: any) => ({
          label: item.deliveryLocationName,
          value: item.id.toString(),
        }));
        setDeliveryAddressOptions(deliveryAddressOptions);
        setDeliveryAddressList(data);
      }
    } catch (error) {
      console.log("Error fetching delivery addresses by site:", error);
    }
  };

  useEffect(() => {
    if (siteIdWatch) {
      fetchDeliveryAddressBySite(siteIdWatch);
      if (
        AllFormDetails?.quotationId ||
        AllFormDetails?.prId ||
        AllFormDetails?.prId ||
        AllFormDetails?.type === "draft"
      )
        return;
      setValue("deliveryAddressId", " ");
    }
  }, [siteIdWatch]);

  const setFormValues = () => {
    const { autoPoDoc, invoicingRequired, priceSlabs, inwardRequired } =
      AllFormDetails;
    if (autoPoDoc) {
      setValue("autoPoDoc", autoPoDoc);
    } else {
      setValue("autoPoDoc", "true");
    }
    if (invoicingRequired) {
      setValue("invoicingRequired", invoicingRequired);
    } else {
      setValue("invoicingRequired", "true");
    }
    if (priceSlabs) {
      setValue("priceSlabs", priceSlabs);
    } else {
      setValue("priceSlabs", "true");
    }
    if (inwardRequired) {
      setValue("inwardRequired", inwardRequired);
    } else {
      setValue("inwardRequired", "true");
    }
    setSettings((prev) => ({
      ...prev,
      data: {
        invoicingRequired: invoicingRequired || "true",
        priceSlabs: priceSlabs || "true",
        inwardRequired: inwardRequired || "true",
        autoPoDoc: autoPoDoc || "true",
      },
    }));
  };

  useEffect(() => {
    fetchSequenceAccess();
    fetchSupplier();
    fetchDeliveryAddress();
  }, []);
  useEffect(() => {
    if (!isFormDataFetched && Object.keys(AllFormDetails).length > 0) {
      setFormValues();
      setIsFormDataFetched(true);
    }
  }, [AllFormDetails]);

  // Validate contract date is on or before start date
  useEffect(() => {
    if (contractDate && startDate) {
      const contract = dayjs(contractDate);
      const start = dayjs(startDate);

      if (contract.isValid() && start.isValid()) {
        if (contract.isAfter(start)) {
          setError("contractDate", {
            type: "manual",
            message: "Contract date must be on or before start date",
          });
        } else {
          clearErrors("contractDate");
        }
      }
    } else {
      clearErrors("contractDate");
    }
  }, [contractDate, startDate]);

  // Clear expiryReminder if it exceeds contract period when dates change
  useEffect(() => {
    if (startDate && endDate) {
      const start = dayjs(startDate);
      const end = dayjs(endDate);

      if (start.isValid() && end.isValid() && end.isAfter(start)) {
        const contractPeriodDays = end.diff(start, "day");
        const currentExpiryReminder = AllFormDetails?.expiryReminder;

        if (
          currentExpiryReminder &&
          Number(currentExpiryReminder) > contractPeriodDays
        ) {
          setValue("expiryReminder", "");
        }
      }
    }
  }, [startDate, endDate]);

  // Initialize approvals from form data when navigating back
  const approvalsDataWatch = watch("approvalsData");
  useEffect(() => {
    if (approvalsDataWatch && !approvals.open && approvals.data.length === 0) {
      try {
        const parsedApprovals =
          typeof approvalsDataWatch === "string"
            ? JSON.parse(approvalsDataWatch)
            : approvalsDataWatch;

        if (
          parsedApprovals &&
          parsedApprovals.data &&
          Array.isArray(parsedApprovals.data) &&
          parsedApprovals.data.length > 0
        ) {
          setApprovals({
            open: false,
            data: parsedApprovals.data,
          });
        }
      } catch (error) {
        console.error("Error parsing approvalsData:", error);
      }
    }
  }, [approvalsDataWatch, approvals.open, approvals.data.length]);

  const selectedSiteIds = Array.isArray(siteIdWatch) ? siteIdWatch : siteIdWatch ? [siteIdWatch] : [];
  const isSingleSiteSelected = selectedSiteIds.length === 1;
  const isMultipleSitesSelected = selectedSiteIds.length > 1;

  const fetchSequenceAccess = async () => {
    try {
      const response = await sequenceApis.fetchSequence();
      const { data } = response;
      const today = new Date();
      const _sequenceAccess = data?.filter(
        (item: any) =>
          item.moduleId === RATE_CONTRACT_MODULE_ID &&
          new Date(item.endDate) > today &&
          item.status === "Active"
      );
      setActiveSequences(_sequenceAccess || []);

      // Check if mode is already persisted in form (e.g. user navigated back from next step)
      const savedMode = getValues("numberingMode");
      if (savedMode) {
        setNumberingMode(savedMode);
        return;
      }

      if (_sequenceAccess && _sequenceAccess.length > 0 && siteIdWatch) {
        // Site-level first: only allow auto when exactly 1 site is selected
        if (isSingleSiteSelected) {
          const hasSiteSequence = _sequenceAccess.some(
            (seq: any) => seq.level === "Site" && seq.siteId?.toString() === selectedSiteIds[0]?.toString()
          );
          if (hasSiteSequence) {
            setNumberingMode('auto');
            return;
          }
        }
        // Org-level fallback: always allow auto regardless of site count
        const hasOrgSequence = _sequenceAccess.some((seq: any) => seq.level === "Org");
        if (hasOrgSequence) {
          setNumberingMode('auto');
          return;
        }
        setNumberingMode('manual');
      } else {
        setNumberingMode('manual');
      }
    } catch (error: any) {
      console.log(error.response?.data?.message || "An error occurred");
      setActiveSequences([]);
      setNumberingMode('manual');
    }
  };

  const getCurrentSiteSequence = () => {
    if (activeSequences.length === 0) return null;

    // Site-level first: only when exactly 1 site is selected
    if (isSingleSiteSelected) {
      const siteSequence = activeSequences.find(
        (seq: any) =>
          seq.level === "Site" &&
          seq.siteId?.toString() === selectedSiteIds[0]?.toString()
      );
      if (siteSequence) return siteSequence;
    }

    // Org-level fallback: always available regardless of site count
    const orgSequence = activeSequences.find(
      (seq: any) => seq.level === "Org"
    );
    if (orgSequence) return orgSequence;

    return null;
  };

  const currentSiteSequence = getCurrentSiteSequence();
  const canAuto = !!currentSiteSequence;

  // Auto-generate number when in auto mode
  useEffect(() => {
    const existingValue = getValues("orderId");
    if (numberingMode === 'auto' && currentSiteSequence && !existingValue) {
      const { prefix } = currentSiteSequence;
      setValue('orderId', prefix);
    }
  }, [numberingMode, currentSiteSequence]);

  const prevSiteRef = useRef(siteIdWatch);

  // Re-fetch sequences when site changes
  useEffect(() => {
    if (siteIdWatch) {
      fetchSequenceAccess();
    } else {
      setActiveSequences([]);
    }
  }, [siteIdWatch]);

  // Reset number and set mode when site changes (not on initial mount)
  useEffect(() => {
    const prevSite = prevSiteRef.current;
    const siteChanged = JSON.stringify(prevSite) !== JSON.stringify(siteIdWatch);

    if (prevSite && siteChanged) {
      setValue("orderId", "");
      // Clear persisted mode so new site gets fresh evaluation
      setValue("numberingMode", "");
    }

    // Respect persisted mode on remount
    const savedMode = getValues("numberingMode");
    if (savedMode) {
      setNumberingMode(savedMode);
    } else if (!siteIdWatch || (Array.isArray(siteIdWatch) && siteIdWatch.length === 0)) {
      setNumberingMode("manual");
    } else if (isMultipleSitesSelected && !activeSequences.some((seq: any) => seq.level === "Org")) {
      // Multiple sites selected with no org-level sequence: force manual
      setNumberingMode("manual");
    } else {
      const siteSequence = getCurrentSiteSequence();
      setNumberingMode(siteSequence ? "auto" : "manual");
    }

    prevSiteRef.current = siteIdWatch;
  }, [siteIdWatch]);

  useEffect(() => {
    if (currentUser) {
      let sitesOptions = currentUser?.siteAccessibility?.map((item: any) => ({
        label: item.siteName,
        value: item.siteID.toString(),
      }));
      setSitesOptions(sitesOptions);
    }
  }, [currentUser]);

  const handleModelPopUp = (id?: any, type?: string) => {
    const content = (
      <DeliveryAddressMaster
        formAction={type}
        id={id}
        toggleModelPopUp={() => {
          setIsOpen(false);
          fetchDeliveryAddress();
        }}
      />
    );
    setPopUpContent(content);
    setIsOpen(true);
  };

  const ShowAddressPopOver = ({ id, text, options, matchKey }: any) => {
    if (!id) {
      return <></>;
    }

    let address = options?.find((item: any) => item[matchKey] == id);

    if (!address) {
      return <></>;
    }
    return (
      <Popover
        content={
          <ul>
            <li>
              {address?.addressLine1} {address?.addressLine2}
            </li>
            <li>
              {address?.city},{address?.districtName}, {address?.stateName},
              {address?.countryName} - {address?.pincode}
            </li>
          </ul>
        }
        title={address?.deliveryLocationName}
      >
        <a>{text}</a>
      </Popover>
    );
  };

  // Check if dates are selected and valid
  const areDatesValid = useMemo(() => {
    if (!startDate || !endDate) {
      return false;
    }
    const start = dayjs(startDate);
    const end = dayjs(endDate);
    return start.isValid() && end.isValid() && end.isAfter(start);
  }, [startDate, endDate]);

  // Calculate contract period in days and filter expiry reminder options
  const expiryReminderOptions = useMemo(() => {
    if (!startDate || !endDate) {
      // If dates are not selected, return empty array
      return [];
    }

    const start = dayjs(startDate);
    const end = dayjs(endDate);

    if (!start.isValid() || !end.isValid() || end.isBefore(start)) {
      // Invalid dates or end date before start date
      return [];
    }

    const contractPeriodDays = end.diff(start, "day");

    // Filter options to only include values <= contract period
    const allOptions = [...Array(20)].map((_, i) => ({
      label: `${(i + 1) * 5}`,
      value: (i + 1) * 5,
    }));

    // Filter to show only options less than contract duration (not equal to)
    return allOptions.filter((option) => option.value < contractPeriodDays);
  }, [startDate, endDate]);

  return (
    <>
      {/* <Row>
        <div
          style={{ justifyContent: "end", display: "flex", marginTop: "-2%" }}
        >
          <Button color="neutral" onClick={openSettingsForm}>
            Settings &nbsp; <SettingOutlined />
          </Button>
        </div>
      </Row>
      <SettingsForm
        open={settings.open}
        onClose={() => {
          setSettings((pre) => {
            return {
              ...pre,
              open: false,
            };
          });
        }}
        prId={AllFormDetails?.prId}
        initialValues={settings.data}
        onSubmit={handleSettingsSubmit}
      /> */}
      <form className="content clearfix" onSubmit={handleSubmit(submitForm)}>
        <Row className="gy-4">
          <Col lg="4">
            <FormDatePicker
              name="contractDate"
              label="Contract Date"
              required={true}
              placeholder="Select Contract Date"
            />
          </Col>
          <Col lg="4">
            <FormMultiSelect
              name="siteId"
              label={`Site`}
              options={sitesOptions}
              required={true}
              placeholder="-Select-"
              disabled={
                AllFormDetails?.quotationId ||
                  AllFormDetails?.prId ||
                  AllFormDetails?.type === "draft"
                  ? true
                  : false
              }
              tooltipText="Select the site where the materials will be used."
            />
          </Col>
          <Col lg="4">
            <div style={{ position: 'relative' }}>
              <FormInput
                name="orderId"
                label={`Contract #`}
                required={numberingMode === 'manual'}
                disabled={numberingMode === 'auto' || AllFormDetails?.type === "draft"}
                placeholder={numberingMode === 'auto' ? 'Auto-generated' : 'Enter RC #'}
              />
              <Tooltip title="Click here to enable or disable auto-generation of contract numbers.">
                <SettingOutlined
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50px',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '18px',
                    color: '#1890ff',
                    zIndex: 1,
                  }}
                  onClick={() => {
                    setTempNumberingMode(numberingMode);
                    setShowNumberingModal(true);
                  }}
                />
              </Tooltip>
            </div>
          </Col>
          <Col lg="4">
            <FormSelect
              name="contractType"
              label={`Contract Type`}
              options={[
                {
                  label: "Open",
                  value: "Open",
                },
                {
                  label: "Quantity",
                  value: "Quantity",
                },
              ]}
              required={true}
              placeholder="-Select-"
              tooltipText="Select the contract type. Open: no min/max quantity restrictions. Quantity: price slabs with min/max quantity."
            />
          </Col>
          <Col lg="4">
            <FormSelect
              name="contractFor"
              label={`Contract For`}
              options={[
                {
                  label: "Material",
                  value: "Material",
                },
                {
                  label: "Service",
                  value: "Service",
                },
              ]}
              required={true}
              placeholder="-Select-"
              tooltipText="Select the contract for the Rate Contract."
              disabled={AllFormDetails?.quotationId ? true : false}
            />
          </Col>
          <Col lg="8">
            <FormInput
              name="description"
              label="Rate Contract Description"
              required={true}
              type="text"
              minLength={2}
              maxLength={500}
              placeholder="Enter Description"
              tooltipText="Enter a brief description of the Rate Contract."
            />
          </Col>
          <Col lg="4">
            <FormSelect
              name="supplierId"
              label={`Supplier/Vendor`}
              options={supplierOptions}
              required={true}
              placeholder="-Select-"
              tooltipText="Select the supplier or vendor for the Rate Contract."
              disabled={AllFormDetails?.quotationId ? true : false}
            />
          </Col>
          <Col lg="4">
            <FormDatePicker
              name="startDate"
              label="Start Date"
              required={true}
              disabled={AllFormDetails?.quotationId ? true : false}
              placeholder="Select Start Date"
            />
          </Col>
          <Col lg="4">
            <FormDatePicker
              name="endDate"
              label="End Date"
              required={true}
              minDate={startDate}
              disabled={AllFormDetails?.quotationId ? true : !startDate}
              placeholder="Select End Date"
            />
          </Col>
          <Col lg="4">
            <FormSelect
              name="expiryReminder"
              label={`Expiry Reminder`}
              options={expiryReminderOptions}
              placeholder={
                areDatesValid ? "-Select-" : "Please select dates first"
              }
              disabled={!areDatesValid}
              tooltipText={
                areDatesValid
                  ? "Select the number of days before contract expiry to receive a reminder. This value cannot exceed the contract period (End Date - Start Date)."
                  : "Please select Start Date and End Date first to enable this field."
              }
            />
          </Col>
          <Col lg="4">
            <FormSelect
              name="approvalRequired"
              label="Auto Release Contract ?"
              options={[
                { label: "Yes", value: "true" },
                { label: "No", value: "false" },
              ]}
              placeholder="Select"
              disabled={!siteIdWatch}
              required={true}
            />
            <div style={{ display: "none" }}>
              <FormInput name="approvalsData" label="" type="text" noMaxLength />
            </div>
            {approvalRequired == "false" && (
              <Popover
                content="Click here to set required approvals"
                title="Approval Required"
              >
                <a
                  href="#"
                  className="success"
                  onClick={(e) => {
                    e.preventDefault();
                    setApprovals((pre) => {
                      return {
                        ...pre,
                        open: true,
                      };
                    });
                  }}
                >
                  <EditOutlined /> Set Approvals &nbsp;
                  {approvals?.data?.length == 0 ? (
                    <span className="mandatory">Please set approvals</span>
                  ) : (
                    <></>
                  )}
                </a>
              </Popover>
            )}
          </Col>
          <Col lg="4">
            <FormSelect
              name="paymentTerms"
              label="Payment Terms"
              options={[
                { label: "Cash & Carry", value: "Cash and Carry" },
                { label: "Advance", value: "Advance" },
                { label: "Credit", value: "Credit" },
              ]}
              required={true}
              placeholder="Select Payment Terms"
              tooltipText="Select the payment terms for the Rate Contract."
            />
          </Col>
          {watch("paymentTerms") === "Advance" && (
            <>
              <Col lg="4">
                <FormInput
                  name="advancePercentage"
                  label="Advance Percentage"
                  required={true}
                  isPercentage={true}
                  placeholder="Enter Advance Percentage"
                  tooltipText="Enter the advance percentage for the Rate Contract."
                />
              </Col>
              {watch("advancePercentage") < 100 && (
                <Col lg="4">
                  <FormInput
                    name="creditDays"
                    label="Credit Days"
                    required={true}
                    type="number"
                    placeholder="Enter Credit Days"
                    tooltipText="Enter the credit days for the Rate Contract."
                    pattern={/^[1-9][0-9]*$/}
                  />
                </Col>
              )}
            </>
          )}
          {watch("paymentTerms") === "Credit" && (
            <Col lg="4">
              <FormInput
                name="creditDays"
                label="Credit Days"
                required={true}
                type="number"
                placeholder="Enter Credit Days"
                tooltipText="Enter the credit days for the Rate Contract."
                pattern={/^[1-9][0-9]*$/}
              />
            </Col>
          )}
          <Col lg="4">
            <FormInput
              name="leadDays"
              label="Delivery Lead Days"
              required={true}
              type="number"
              placeholder="Enter Delivery Lead Days"
              tooltipText="Enter the Delivery lead days for the Rate Contract."
              pattern={/^[1-9][0-9]*$/}
            />
          </Col>
        </Row>
        <Row className="gy-4 mt-1">
          <Col>
            <Button color="primary" type="submit">
              Next
            </Button>
          </Col>
        </Row>
      </form>
      {approvals.open && (
        <RateContractApprovalDrawer
          open={approvals.open}
          siteId={siteIdWatch}
          onClose={() => {
            setApprovals((pre) => {
              return {
                ...pre,
                open: false,
              };
            });
          }}
          onSubmit={(data: any, isStrictApprovalFromDrawer: boolean) => {
            setApprovals({
              open: false,
              data: data,
            });
            setIsStrictApproval(isStrictApprovalFromDrawer);
          }}
          initialStrictApproval={isStrictApproval}
          setApprovalSubmissionStatus={(status: boolean) => { }}
          approvalData={approvals.data} // Pass the current approval data
        />
      )}
      <Modal
        isOpen={isOpen}
        toggle={() => setIsOpen(false)}
        className="modal-dialog-centered"
        size="xl"
        backdrop="static"
      >
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setIsOpen(false);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>

        <ModalBody>{popUpContent}</ModalBody>
      </Modal>

      {/* Contract Number Configuration Modal */}
      <AntdModal
        title="Configure Contract Number Preference"
        open={showNumberingModal}
        onCancel={() => setShowNumberingModal(false)}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-start", gap: "10px" }}>
            <Button
              key="save"
              color="primary"
              onClick={() => {
                if (tempNumberingMode === "auto" && !currentSiteSequence) {
                  message.error("Auto-generation is not configured.");
                  return;
                }

                setNumberingMode(tempNumberingMode);

                if (tempNumberingMode === "auto" && currentSiteSequence) {
                  const { prefix } = currentSiteSequence;
                  setValue("orderId", prefix);
                } else if (tempNumberingMode === "manual") {
                  setValue("orderId", "");
                }
                setShowNumberingModal(false);
              }}
            >
              Save
            </Button>
            <Button
              key="cancel"
              color="primary"
              onClick={() => setShowNumberingModal(false)}
            >
              Cancel
            </Button>
          </div>
        }
      >
        <div style={{ marginBottom: 20, lineHeight: "22px" }}>
          Your contract numbers are currently set to auto-generate to save time.
          <br />
          Are you sure you want to change this setting?
        </div>

        {isMultipleSitesSelected && !activeSequences.some((seq: any) => seq.level === "Org") && (
          <div style={{ color: "#faad14", marginBottom: 16 }}>
            <InfoCircleOutlined />{" "}
            Auto-generation is available when a single site is selected.
          </div>
        )}

        {!currentSiteSequence && !isMultipleSitesSelected && (
          <div style={{ color: "#faad14", marginBottom: 16 }}>
            <InfoCircleOutlined />{" "}
            {activeSequences.length === 0
              ? "No sequences configured for Rate Contracts. Please set up a sequence first."
              : "No sequence configured. Please set a sequence first."}
          </div>
        )}

        <Radio.Group
          onChange={(e) => setTempNumberingMode(e.target.value)}
          value={tempNumberingMode}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            <Radio value="auto" disabled={!canAuto}>
              <span style={{ fontWeight: 500 }}>
                Continue auto-generating contract numbers
              </span>
            </Radio>
            <Radio value="manual">
              <span style={{ fontWeight: 500 }}>
                Enter contract numbers manually
              </span>
            </Radio>
          </Space>
        </Radio.Group>
      </AntdModal>
    </>
  );
};

export default RateContract_GeneralDetails;
